"use client"

import { useEffect, useState } from "react"
import Api from "../../config/Api"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { useForm, Controller } from "react-hook-form"
import DatePicker from "react-multi-date-picker"
import dayjs from "dayjs"
import StatusBadge from "../SDRFManagement/Application/Components/StatusBadge"
import { FaRegFileExcel, FaRegFilePdf } from "react-icons/fa"
import TooltipWidget from "../Components/Widget/TooltipWidget"
import Status from "./Components/status.json"
import Loader from "../Components/Widget/Loader"
import ModalBox from "../Components/Widget/ModalBox"
import Select from "react-select"
import DataTable from "react-data-table-component"

const CalamityReport = () => {
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm()

  const {
    handleSubmit: handleSubmit1,
    register: register1,
    formState: { errors: errors1 },
  } = useForm()

  const admin = useSelector((state) => JSON.parse(state.authentication.admin))
  const [isLoading, setIsLoading] = useState(false)
  const [application, setApplication] = useState([])
  const [applicationCount, setApplicationCount] = useState(0)
  const [natureDisasterList, setNatureDisasterList] = useState([])
  const [isApplicationLoaded, setIsApplicationLoaded] = useState(false)
  const [filter, setFilter] = useState("")
  const [currentStatus, setCurrentStatus] = useState("")
  const [currentDate, setCurrentDate] = useState("")
  const [currentNatureDisaster, setCurrentNatureDisaster] = useState("")
  const [isExcelDownloadModalShow, setIsExcelDownloadModalShow] = useState(false)
  const [isPdfDownloadModalShow, setIsPdfDownloadModalShow] = useState(false)
  const [pdfNumberList, setPdfNumberList] = useState([])

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(20)

  // Additional filter states from GenerateReport
  const [districtList, setDistrictList] = useState([])
  const [damageLevel1List, setDamageLevel1List] = useState([])
  const [damageLevel2List, setDamageLevel2List] = useState([])
  const [damageLevel3List, setDamageLevel3List] = useState([])
  const [isThirdDropdownShow, setIsThirdDropdownShow] = useState(false)
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [currentGender, setCurrentGender] = useState("")
  const [currentDeceased, setCurrentDeceased] = useState("")
  const [currentFirstDamage, setCurrentFirstDamage] = useState("")
  const [currentSecondDamage, setCurrentSecondDamage] = useState("")
  const [currentThirdDamage, setCurrentThirdDamage] = useState("")
  const [currentSanctionLetter, setCurrentSanctionLetter] = useState("")
  const [currentLocationDisaster, setCurrentLocationDisaster] = useState("")
  const [currentPincode, setCurrentPincode] = useState("")
  const [currentVillage, setCurrentVillage] = useState("")
  const [currentTown, setCurrentTown] = useState("")
  const [currentAdminCircle, setCurrentAdminCircle] = useState("")
  const [currentPoliceStation, setCurrentPoliceStation] = useState("")

  // API functions from GenerateReport
  const District = async () => {
    const res = await Api("get-district")
    setDistrictList(res?.data?.district)
  }

  const style = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? "1px solid #224b8b" : "1px solid #ddd",
      boxShadow: "none",
      backgroundColor: state.isFocused ? "#fff" : "#fff",
      "&:hover": {
        borderColor: "#224b8b",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#224b8b" : "",
      "&:hover": {
        color: "#fff",
        backgroundColor: "#224b8b",
      },
    }),
  }

  const level1Option = (data) => {
    return data
      ?.filter((d) => d.status === "Active")
      .map((item) => ({
        label: item.title,
        value: item.id,
        ...item,
      }))
  }

  const level2Option = (data) => {
    return data
      ?.filter((d) => d.status === "Active")
      .map((item) => ({
        label: item.damage_name,
        value: item.id,
        ...item,
      }))
  }

  const level3Option = (data) => {
    return data
      ?.filter((d) => d.status === "Active")
      .map((item) => ({
        label: !!item?.second_damage?.extent_unit ? `${item.name} (${item?.second_damage?.extent_unit})` : item.name,
        value: item.id,
        ...item,
      }))
  }

  const getlevel1 = async () => {
    try {
      const res = await Api("first_damage_classification_get")
      if (res.data.status === "1") {
        setDamageLevel1List(level1Option(res.data.DamageClassificationData.reverse()))
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
  }

  const getlevel2 = async (id) => {
    try {
      const res = await Api(`second_damage_classification_get/${id}`)
      if (res.data.status === 1) {
        setDamageLevel2List(level2Option(res.data.DamageClassificationData))
        return true
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
  }

  const getlevel3 = async (id) => {
    setIsThirdDropdownShow(false)
    setValue("third_damage_classification_id", "")
    try {
      const res = await Api(`third_damage_classification_get/${id}`)
      if (res.data.status === 1) {
        setDamageLevel3List(level3Option(res.data.data))
        if (res.data.data.length > 1) {
          setIsThirdDropdownShow(true)
        } else {
          const tempData = {
            label: res.data.data[0].name,
            value: res.data.data[0].id,
            ...res.data.data[0],
          }
          setValue("third_damage_classification_id", tempData)
        }
        return true
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
  }

  const excelDownloadModalShow = () => {
    setIsExcelDownloadModalShow(true)
  }

  const excelDownloadModalclose = () => {
    setIsExcelDownloadModalShow(false)
  }

  const pdfDownloadModalShow = () => {
    setIsPdfDownloadModalShow(true)
  }

  const pdfDownloadModalclose = () => {
    setIsPdfDownloadModalShow(false)
  }

  const onDownloadExcel = (d) => {
    downloadExcell(d?.range)
  }

  const onDownloadPdf = (d) => {
    downloadPdff(d?.range)
  }

  const downloadExcell = async (range) => {
    try {
      const start_no = range.split("-")[0]
      const nature_disaster = !!currentNatureDisaster ? `nature_disaster[]=${currentNatureDisaster}` : null
      const district_id = currentDistrict ? currentDistrict : null
      const start_date = currentDate?.start_date ? currentDate?.start_date : null
      const end_date = currentDate?.end_date ? currentDate?.end_date : null
      const baseUrl = process.env.REACT_APP_API_URL
      const endpoint = "export_sdrf_report_per_calamity"
      const status = !!currentStatus ? `status[]=${currentStatus}` : null

      let url
      if (Boolean(currentNatureDisaster)) {
        url = `${baseUrl}${endpoint}?nature_disaster=${nature_disaster}&start_no=${start_no}&${status}`
      } else if (Boolean(currentDistrict)) {
        url = `${baseUrl}${endpoint}?district_id=${district_id}&start_no=${start_no}&${status}`
      } else if (currentDate) {
        url = `${baseUrl}${endpoint}?start_date=${start_date}&end_date=${end_date}&start_no=${start_no}`
      } else {
        url = `${baseUrl}${endpoint}?${status}&start_no=${start_no}`
      }

      window.open(url, "_blank")
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
  }

  const downloadPdff = async (range) => {
    try {
      const start_no = range.split("-")[0]
      const nature_disaster = !!currentNatureDisaster ? `nature_disaster[]=${currentNatureDisaster}` : null
      const district_id = currentDistrict ? currentDistrict : null
      const start_date = currentDate?.start_date ? currentDate?.start_date : null
      const end_date = currentDate?.end_date ? currentDate?.end_date : null
      const baseUrl = process.env.REACT_APP_API_URL
      const endpoint = `pdf-sdrfreport-per-calamity/${admin.id}`
      const status = !!currentStatus ? `status[]=${currentStatus}` : null

      let url
      if (Boolean(currentNatureDisaster)) {
        url = `${baseUrl}${endpoint}?nature_disaster=${nature_disaster}&start_no=${start_no}&${status}`
      } else if (Boolean(currentDistrict)) {
        url = `${baseUrl}${endpoint}?district_id=${district_id}&start_no=${start_no}&${status}`
      } else if (currentDate) {
        url = `${baseUrl}${endpoint}?start_date=${start_date}&end_date=${end_date}&start_no=${start_no}`
      } else {
        url = `${baseUrl}${endpoint}?${status}&start_no=${start_no}`
      }

      window.open(url, "_blank")
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
    }
  }

  const setPdfList = () => {
    const rangeSize = 200
    const maxValue = applicationCount
    const result = []

    for (let i = 1; i <= maxValue; i += rangeSize) {
      const start = i
      const end = Math.min(i + rangeSize - 1, maxValue)
      const rangeString = `${start}-${end}`
      result.push(rangeString)
    }

    setPdfNumberList(result)
  }

  const natureDisaster = async () => {
    const res = await Api("nature_of_disaster_get")
    setNatureDisasterList(res?.data?.NatureOfDisaster)
  }

  const getCurrentFilters = () => ({
    gender: currentGender,
    deceased: currentDeceased,
    nature_disaster: currentNatureDisaster,
    first_damage_classification_id: currentFirstDamage?.value,
    second_damage_classification_id: currentSecondDamage?.value,
    third_damage_classification_id: currentThirdDamage?.value,
    sanction_letter_number: currentSanctionLetter,
    location_disaster: currentLocationDisaster,
    pincode: currentPincode,
    village: currentVillage,
    town: currentTown,
    admin_circle: currentAdminCircle,
    police_station: currentPoliceStation,
    district_id: currentDistrict,
  })

  // Modified API call to include all additional filters
  const getApplication = async (
    status_id,
    nature_disaster,
    page = 1,
    search = "",
    dates = null,
    additionalFilters = {},
  ) => {
    try {
      setIsLoading(true)
      const body = {
        page: page,
        per_page: perPage,
        search: search,
      }

      if (Boolean(status_id)) {
        body.status = status_id
      }

      if (Boolean(nature_disaster)) {
        body.nature_disaster = nature_disaster
      }

      if (dates) {
        body.start_date = dates.start_date
        body.end_date = dates.end_date
      }

      // Add additional filters
      Object.keys(additionalFilters).forEach((key) => {
        if (additionalFilters[key]) {
          body[key] = additionalFilters[key]
        }
      })

      const res = await Api("sdrf_report_per_calamity", "POST", body, true)

      if (res.data.status === 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        setApplication(res.data.data.data || res.data.data)
        setApplicationCount(res.data?.data?.total || res.data.total || 0)

        // Set pagination metadata
        if (res.data.data && typeof res.data.data === "object" && res.data.data.current_page) {
          setCurrentPage(res.data.data.current_page)
          setTotalPages(res.data.data.last_page)
          setTotalRecords(res.data.data.total)
          setPerPage(res.data.data.per_page)
        } else {
          // Fallback for simple array response
          setCurrentPage(page)
          setTotalRecords(res.data.count || res.data.total || 0)
          setTotalPages(Math.ceil((res.data.count || res.data.total || 0) / perPage))
        }

        setIsApplicationLoaded(true)
        setIsLoading(false)
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
        setIsLoading(false)
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      setIsLoading(false)
    }
  }

  // Handle search with server-side call
  const handleSearch = (searchTerm) => {
    setFilter(searchTerm)
    // setCurrentPage(1)
    // getApplication(currentStatus, currentNatureDisaster, 1, searchTerm, currentDate, getCurrentFilters())
  }

  // Handle page change for DataTable
  const handlePageChange = (page) => {
    setCurrentPage(page)
    getApplication(currentStatus, currentNatureDisaster, page, filter, currentDate, getCurrentFilters())
  }

  // Handle per page change for DataTable
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    getApplication(currentStatus, currentNatureDisaster, page, filter, currentDate, getCurrentFilters())
  }

  useEffect(() => {
    natureDisaster()
    District()
    getlevel1()
    getApplication(currentStatus)
  }, [])

  const filterStatus = (e) => {
    const status = e.target.value
    setCurrentStatus(status)
  }

  const filterNatureDisaster = (e) => {
    const disaster = e.target.value
    setCurrentNatureDisaster(disaster)
  }

  const filterDistrict = (e) => {
    const district = e.target.value
    setCurrentDistrict(district)
    setValue("count_date_range", "")
  }

  // FIXED: Updated onSubmit function to properly apply all filters with date range
  const onSubmit = (data) => {
    const dateBody = {
      start_date: "",
      end_date: "",
    }

    if (data.count_date_range === "Current Financial Year") {
      if (dayjs().format("M") > 2) {
        dateBody.start_date = dayjs("1 3", "D M").format("YYYY-MM-DD")
        dateBody.end_date = dayjs("2", "M").add(1, "year").endOf("month").format("YYYY-MM-DD")
      } else {
        dateBody.start_date = dayjs("1 3", "D M").subtract(1, "year").format("YYYY-MM-DD")
        dateBody.end_date = dayjs("2", "M").endOf("month").format("YYYY-MM-DD")
      }
    } else if (data.count_date_range === "Daily") {
      dateBody.start_date = dayjs().format("YYYY-MM-DD")
      dateBody.end_date = dayjs().format("YYYY-MM-DD")
    } else if (data.count_date_range === "Weekly") {
      dateBody.start_date = dayjs().format("YYYY-MM-DD")
      dateBody.end_date = dayjs().format("YYYY-MM-DD")
    } else if (data.count_date_range === "Current Month") {
      dateBody.start_date = dayjs().startOf("month").format("YYYY-MM-DD")
      dateBody.end_date = dayjs().endOf("month").format("YYYY-MM-DD")
    } else if (data.count_date_range === "Previous Month") {
      dateBody.start_date = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD")
      dateBody.end_date = dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
    } else if (data.count_date_range === "Custom Dates") {
      dateBody.start_date = dayjs(data?.count_start_date, "DD MMM YYYY").format("YYYY-MM-DD")
      dateBody.end_date = dayjs(data?.count_end_date, "DD MMM YYYY").format("YYYY-MM-DD")
    }

    // Set the current date for other functions to use
    setCurrentDate(dateBody)
    setCurrentPage(1)
    setIsApplicationLoaded(false)

    // Call getApplication with all current filters AND the date range
    getApplication(currentStatus, currentNatureDisaster, 1, filter, dateBody, getCurrentFilters())
  }

  useEffect(() => {
    setPdfList()
  }, [applicationCount])

  // DataTable columns configuration
  const columns = [
    {
      name: "#",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "Application ID",
      selector: (row) => row.application_id,
      sortable: true,
      width: "150px",
    },
    {
      name: "Applicant Name",
      selector: (row) => row.applicant_name,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.applicant_name}</div>
          <small className="text-muted">{row.mobile}</small>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Nature Of Disaster",
      selector: (row) => row?.nature?.map((item) => item?.title).join(", "),
      sortable: false,
      width: "120px",
    },
    {
      name: "Item Damaged",
      selector: (row) =>
        row?.application_third_meta?.map((item) => item?.first_damage_classification?.title).join(", "),
      sortable: false,
      width: "150px",
    },
    {
      name: "Category",
      selector: (row) =>
        row?.application_third_meta?.map((item) => item?.second_damage_classification?.damage_name).join(", "),
      sortable: false,
      width: "180px",
    },
    {
      name: "Date Of Occurrence",
      selector: (row) => row.date_of_occurrence,
      sortable: true,
      width: "150px",
    },
    {
      name: "District",
      selector: (row) => row.district?.district_name,
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => <StatusBadge status={row.status} />,
      width: "120px",
    },
  ]

  // Custom styles for DataTable
  const customStyles = {
    table: {
      style: {
        minHeight: "30px",
        border: "1px solid rgba(0,0,0,.12)",
      },
    },
    headCells: {
      style: {
        padding: "5px",
        minHeight: "30px",
        "&:not(:last-child)": {
          borderRight: "1px solid rgba(0,0,0,.12)",
        },
      },
    },
    cells: {
      style: {
        padding: "5px",
        wordBreak: "break-word",
        lineHeight: "1.4",
        "&:not(:last-child)": {
          borderRight: "1px solid rgba(0,0,0,.12)",
        },
      },
    },
    rows: {
      style: {
        minHeight: "30px",
        borderColor: "#000",
        "&:hover": {
          outline: "0 !important",
          borderColor: "rgba(0,0,0,.12) !important",
        },
      },
    },
  }

  return (
    <>
      <div className="bg-white p-3 rounded shadow">
        <div className="mb-2">
          <div>
            <h5 className="text-dark">Generate Report By Calamity</h5>
          </div>
          <div className="row g-2">
            <div className="col-xl-12">
              <div className="mb-2">
               
                {/* Advanced Filters */}
                <div className="row g-2 mb-2">
                <div className="col-lg-3 col-md col-sm-4">
                    <select {...register("count_date_range")} className="form-select">
                      <option value="">Please Select Date Range</option>
                      <option value="Current Financial Year">Current Financial Year</option>
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="Current Month">Current Month</option>
                      <option value="Previous Month">Previous Month</option>
                      <option value="Custom Dates">Custom Dates</option>
                    </select>
                  </div>
                  {watch("count_date_range") === "Custom Dates" && (
                    <>
                      <div className="col-lg-2 col-md col-sm-4 col-6">
                        <Controller
                          control={control}
                          name="count_start_date"
                          rules={{ required: true }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              inputClass="form-control"
                              maxDate={new Date()}
                              placeholder="Start Date"
                              format="DD MMM YYYY"
                              editable={true}
                              value={field.value || ""}
                              onChange={(date) => {
                                field.onChange(date?.format?.("DD MMM YYYY"))
                              }}
                            />
                          )}
                        />
                        {errors.count_start_date && <div className="error_line">Start date is required</div>}
                      </div>
                      <div className="col-lg-2 col-md col-sm-4 col-6">
                        <Controller
                          control={control}
                          name="count_end_date"
                          rules={{ required: true }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              inputClass="form-control"
                              maxDate={new Date()}
                              minDate={dayjs(watch("count_start_date"), "DD MMM YYYY").$d}
                              placeholder="End Date"
                              format="DD MMM YYYY"
                              editable={true}
                              value={field.value || ""}
                              onChange={(date) => {
                                field.onChange(date?.format?.("DD MMM YYYY"))
                              }}
                            />
                          )}
                        />
                        {errors.count_end_date && <div className="error_line">End date is required</div>}
                      </div>
                    </>
                  )}

                  <div className="col-sm-6 col-lg-3">
                    <select
                      className="form-select"
                      value={currentGender}
                      onChange={(e) => {
                        setCurrentGender(e.target.value)
                      }}
                      disabled={isLoading}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <select
                      className="form-select"
                      value={currentDeceased}
                      onChange={(e) => {
                        setCurrentDeceased(e.target.value)
                      }}
                      disabled={isLoading}
                    >
                      <option value="">Select Deceased</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <Select
                      value={currentFirstDamage}
                      isDisabled={isLoading}
                      styles={style}
                      placeholder="Select Item Damaged"
                      options={damageLevel1List}
                      onChange={(e) => {
                        setCurrentFirstDamage(e)
                        setCurrentSecondDamage("")
                        setCurrentThirdDamage("")
                        setIsThirdDropdownShow(false)
                        setDamageLevel3List([])
                        if (e) {
                          getlevel2(e.value)
                        }
                      }}
                      isClearable
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <Select
                      value={currentSecondDamage}
                      isDisabled={isLoading}
                      styles={style}
                      placeholder="Select Category"
                      options={damageLevel2List}
                      onChange={(e) => {
                        setCurrentSecondDamage(e)
                        setCurrentThirdDamage("")
                        if (e) {
                          getlevel3(e.value)
                        }
                      }}
                      isClearable
                    />
                  </div>
              
                  {isThirdDropdownShow && (
                    <div className="col-sm-6 col-lg-3">
                      <Select
                        value={currentThirdDamage}
                        isDisabled={isLoading}
                        styles={style}
                        placeholder="Select Sub Category"
                        options={damageLevel3List}
                        onChange={(e) => {
                          setCurrentThirdDamage(e)
                        }}
                        isClearable
                      />
                    </div>
                  )}

                  <div className="col-sm-6 col-lg-3">
                    <input
                      type="text"
                      placeholder="Sanction Letter Number"
                      className="form-control"
                      value={currentSanctionLetter}
                      onChange={(e) => {
                        setCurrentSanctionLetter(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <input
                      type="text"
                      placeholder="Location Of Disaster"
                      className="form-control"
                      value={currentLocationDisaster}
                      onChange={(e) => {
                        setCurrentLocationDisaster(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <input
                      type="text"
                      placeholder="Pincode"
                      className="form-control"
                      value={currentPincode}
                      onChange={(e) => {
                        setCurrentPincode(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3">
                    <input
                      type="text"
                      placeholder="Village/Colony/Ward"
                      className="form-control"
                      value={currentVillage}
                      onChange={(e) => {
                        setCurrentVillage(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <input
                      type="text"
                      placeholder="City/Town"
                      className="form-control"
                      value={currentTown}
                      onChange={(e) => {
                        setCurrentTown(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <input
                      type="text"
                      placeholder="Admin Circle/Sub-division"
                      className="form-control"
                      value={currentAdminCircle}
                      onChange={(e) => {
                        setCurrentAdminCircle(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <input
                      type="text"
                      placeholder="Police Station"
                      className="form-control"
                      value={currentPoliceStation}
                      onChange={(e) => {
                        setCurrentPoliceStation(e.target.value)
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <select
                      className="form-select"
                      name="district_name"
                      value={currentDistrict}
                      onChange={filterDistrict}
                      disabled={isLoading}
                    >
                      <option value="">All Districts</option>
                      {districtList
                        ?.filter((districts) => districts.status === "Active")
                        .map((districts) => (
                          <option value={districts?.id} key={districts?.id}>
                            {districts?.district_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <select
                      className="form-select"
                      name="title"
                      value={currentNatureDisaster}
                      onChange={filterNatureDisaster}
                      disabled={isLoading}
                    >
                      <option value="">Select Disaster</option>
                      {natureDisasterList
                        ?.filter((NatureOfDisaster) => NatureOfDisaster.status === "Active")
                        .map((NatureOfDisaster) => (
                          <option value={NatureOfDisaster?.id} key={NatureOfDisaster?.id}>
                            {NatureOfDisaster?.title}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <select
                      className="form-select"
                      name="status"
                      value={currentStatus}
                      onChange={filterStatus}
                      disabled={isLoading}
                    >
                      <option value="">All Status</option>
                      {Status?.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-sm-6 col-lg-3 mt-2">
                    <input
                      type="text"
                      placeholder="Search Application"
                      className="form-control"
                      value={filter}
                      onChange={(e) => handleSearch(e.target.value)}
                      disabled={isLoading}
                    />
                  </div>

                   {/* Show Button and Download Buttons */}
                   <div className="col-auto">
                    <div className="d-flex gap-2">
                      <form onSubmit={handleSubmit(onSubmit)} className="d-inline">
                        <input type="submit" value="Show" className="btn btn-primary px-4" disabled={isLoading} />
                      </form>
                      <TooltipWidget title="Download Excel">
                        <button onClick={excelDownloadModalShow} className="btn btn-success" type="button">
                          <FaRegFileExcel />
                        </button>
                      </TooltipWidget>
                      <TooltipWidget title="Download PDF">
                        <button onClick={pdfDownloadModalShow} className="btn btn-danger" type="button">
                          <FaRegFilePdf />
                        </button>
                      </TooltipWidget>
                    </div>
                  </div>

                </div>

               
              </div>
            </div>
          </div>
        </div>

        {/* DataTable Implementation */}
        <div className="table-responsive">
          {isApplicationLoaded ? (
            <DataTable
              columns={columns}
              data={application}
              progressPending={isLoading}
              pagination
              paginationServer
              paginationTotalRows={totalRecords}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              customStyles={customStyles}
              noDataComponent={
                <div className="text-center py-4 text-muted">
                  <div className="text-muted">No calamity reports found</div>
                </div>
              }
              striped
              highlightOnHover
              responsive
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>

      {/* Modals */}
      <ModalBox show={isExcelDownloadModalShow} hide={excelDownloadModalclose} title="Choose range for download Excel">
        <div className="">
          <form onSubmit={handleSubmit1(onDownloadExcel)}>
            <div className="row g-3 justify-content-center">
              <div className="col-md-12">
                <select className="form-select" {...register1("range", { required: true })}>
                  <option value="">Select Range</option>
                  {pdfNumberList?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors1.range && <div className="error_line">Range is required</div>}
              </div>
              <div className="col-md-4">
                <input className="btn btn-primary w-100" type="submit" value="Submit" />
              </div>
            </div>
          </form>
        </div>
      </ModalBox>

      <ModalBox show={isPdfDownloadModalShow} hide={pdfDownloadModalclose} title="Choose range for download PDF">
        <div className="">
          <form onSubmit={handleSubmit1(onDownloadPdf)}>
            <div className="row g-3 justify-content-center">
              <div className="col-md-12">
                <select className="form-select" {...register1("range", { required: true })}>
                  <option value="">Select Range</option>
                  {pdfNumberList?.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors1.range && <div className="error_line">Range is required</div>}
              </div>
              <div className="col-md-4">
                <input className="btn btn-primary w-100" type="submit" value="Submit" />
              </div>
            </div>
          </form>
        </div>
      </ModalBox>
    </>
  )
}

export default CalamityReport
